// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DOpwx","colBig":"styles_colBig__KyXFk","colSmall":"styles_colSmall__2ypan"};